import LocationModel from '../model/LocationModel'
import TextControl from '../../../lib/ui/TextControl'
import UrlControl from '../../../lib/ui/UrlControl'
import PickerControl from '../../../lib/ui/PickerControl'
import PhonenumberControl from '../../../lib/ui/PhonenumberControl'
import FaxnumberControl from '../../../lib/ui/FaxnumberControl'
import EmailControl from '../../../lib/ui/EmailControl'
import SelectOrganisation from '../../organisation/action/SelectOrganisation'
import SelectControl from '../../../lib/ui/SelectControl'
import GoogleMapsButtonControl from '../../../lib/ui/GoogleMapsButtonControl'
import CountryOptions from '../../constants/CountryOptions'

export default class LocationForm {
  constructor (element, args) {
    let fieldsetLocation = document.createElement('fieldset')
    let legendLocation = document.createElement('legend')
    legendLocation.innerHTML = 'Vestiging'
    fieldsetLocation.appendChild(legendLocation)

    this.id = args.location.values.id
    let popup = null

    this.organisation = new PickerControl(fieldsetLocation, {label: 'Organisatie', value: args.location.values.organisation_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/organisations/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectOrganisation(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.organisation.setValue(item.values.id, item)
            } else {
              this.organisation.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.organisation.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.business = new TextControl(fieldsetLocation, {label: 'Business', value: args.location.values.business, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})

    let fieldsetContact = document.createElement('fieldset')
    let legendContact = document.createElement('legend')
    legendContact.innerHTML = 'Contact gegevens'
    fieldsetContact.appendChild(legendContact)

    this.phone = new PhonenumberControl(fieldsetContact, {label: 'Telefoon', value: args.location.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.fax = new FaxnumberControl(fieldsetContact, {label: 'Fax', value: args.location.values.fax, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.email = new EmailControl(fieldsetContact, {label: 'E-mail', value: args.location.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.website = new UrlControl(fieldsetContact, {label: 'Website', value: args.location.values.website, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})

    let fieldsetPost = document.createElement('fieldset')
    let legendPost = document.createElement('legend')
    legendPost.innerHTML = 'Postadres'
    fieldsetPost.appendChild(legendPost)

    this.postaddress = new TextControl(fieldsetPost, {label: 'Adres', value: args.location.values.postaddress, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.postzipcode = new TextControl(fieldsetPost, {label: 'Postcode', value: args.location.values.postzipcode, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.postcity = new TextControl(fieldsetPost, {label: 'Plaats', value: args.location.values.postcity, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.postregion = new TextControl(fieldsetPost, {label: 'Provincie', value: args.location.values.postregion, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.postcountry = new SelectControl(fieldsetPost, {label: 'Land', value: args.location.values.postcountry, options: CountryOptions, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})

    let fieldsetAddress = document.createElement('fieldset')
    let legendAddress = document.createElement('legend')
    legendAddress.innerHTML = 'Bezoekersadres'
    fieldsetAddress.appendChild(legendAddress)

    this.address = new TextControl(fieldsetAddress, {label: 'Adres', value: args.location.values.visitaddress, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.zipcode = new TextControl(fieldsetAddress, {label: 'Postcode', value: args.location.values.visitzipcode, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.city = new TextControl(fieldsetAddress, {label: 'Plaats', value: args.location.values.visitcity, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.region = new TextControl(fieldsetAddress, {label: 'Provincie', value: args.location.values.visitregion, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.country = new SelectControl(fieldsetAddress, {label: 'Land', value: args.location.values.visitcountry, options: CountryOptions, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange})
    this.addressGoogleMaps = new GoogleMapsButtonControl(fieldsetAddress, {getValues: () => {
        return [
          this.address.getValue(),
          this.zipcode.getValue(),
          this.city.getValue(),
          this.region.getValue(),
          this.country.getValue()
        ]
    }})

    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetLocation)
    fragment.appendChild(fieldsetContact)
    fragment.appendChild(fieldsetPost)
    fragment.appendChild(fieldsetAddress)

    element.appendChild(fragment)
  }

  getValue () {
    let location = new LocationModel()
    location.organisation = this.organisation.getItem()
    location.values.id = this.id
    location.values.organisation_id = this.organisation.getValue()
    location.values.business = this.business.getValue()
    location.values.postaddress = this.postaddress.getValue()
    location.values.postzipcode = this.postzipcode.getValue()
    location.values.postcity = this.postcity.getValue()
    location.values.postregion = this.postregion.getValue()
    location.values.postcountry = this.postcountry.getValue()
    location.values.phone = this.phone.getValue()
    location.values.email = this.email.getValue()
    location.values.fax = this.fax.getValue()
    location.values.website = this.website.getValue()
    location.values.visitaddress = this.address.getValue()
    location.values.visitzipcode = this.zipcode.getValue()
    location.values.visitcity = this.city.getValue()
    location.values.visitregion = this.region.getValue()
    location.values.visitcountry = this.country.getValue()
    return location
  }

  setValue (location) {
    this.id = location.values.id
    this.organisation.setValue(location.values.organisation_id, location.organisation)
    this.business.setValue(location.values.business)
    this.postaddress.setValue(location.values.postaddress)
    this.postzipcode.setValue(location.values.postzipcode)
    this.postcity.setValue(location.values.postcity)
    this.postregion.setValue(location.values.postregion)
    this.postcountry.setValue(location.values.postcountry)
    this.phone.setValue(location.values.phone)
    this.email.setValue(location.values.email)
    this.fax.setValue(location.values.fax)
    this.website.setValue(location.values.website)
    this.address.setValue(location.values.visitaddress)
    this.zipcode.setValue(location.values.visitzipcode)
    this.city.setValue(location.values.visitcity)
    this.region.setValue(location.values.visitregion)
    this.country.setValue(location.values.visitcountry)
  }
}



// WEBPACK FOOTER //
// ./js/modules/location/ui/LocationForm.js